import React from 'react';
import { Modal } from 'react-bootstrap';

const ReusableModal = ({
    show = false,
    onHide,
    title,
    size = "xl",
    centered = true,
    backdrop = "static",
    bodyStyle = { minHeight: '50vh', padding: '0px' },
    children,
    actions = [],
    showCloseButton = true,
    closeButtonText = "Close",
    closeButtonVariant = "light"
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size={size}
            centered={centered}
            backdrop={backdrop}
        >
            {title && (
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
            )}
            
            <Modal.Body style={bodyStyle}>
                {children}
            </Modal.Body>
            
            <Modal.Footer>
                {showCloseButton && (
                    <button 
                        type="button" 
                        className={`btn btn-${closeButtonVariant}`}
                        onClick={onHide}
                    >
                        {closeButtonText}
                    </button>
                )}
                
                {actions.map((action, index) => (
                    <button
                        key={index}
                        type="button"
                        className={`btn ${action.className || 'btn-primary'}`}
                        onClick={action.onClick}
                        disabled={action.disabled}
                    >
                        {action.icon && <i className={`${action.icon} me-2`}></i>}
                        {action.text}
                    </button>
                ))}
            </Modal.Footer>
        </Modal>
    );
};

export default ReusableModal; 